import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular/standalone';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  constructor(private loadingController: LoadingController) {}

  private displayed = false;
  async create(spinner: 'circles', cssClass?: string): Promise<void> {
    const loading = await this.loadingController.create({ spinner, cssClass });
    await loading.present();
    this.displayed = true;
  }

  async dismiss(): Promise<void> {
    if (this.displayed) {
      this.displayed = false;
      void this.loadingController.dismiss();
    }
  }
}
